import { IInfiniteData } from '../../../../types';

import { IPodInventoryListResponse } from '../../../types';

/**
 * Format the response of the Pod packages list items.
 */
export function formatPodPackagesListResponse(
  data: IInfiniteData<IPodInventoryListResponse> | undefined
): IPodInventoryListResponse {
  if (!data?.pages) {
    return { podInventories: [], total: 0 };
  }

  let total = 0;
  const podInventories = data.pages.flatMap((page) => {
    total = page.total;
    return page.podInventories;
  });

  return { podInventories, total };
}
